import React from 'react';
import './Dashboard.css';
import Sidebar from './Sidebar';
import MainContent from './MainContent';

const Dashboard = () => {
  return (
    <div className="dashboard-container">
      <div className="dashboard-sidebar-wrapper">
        <Sidebar />
      </div>
      <div className="dashboard-main-wrapper">
        <MainContent />
      </div>
    </div>
  );
};

export default Dashboard;
